import type { FC } from 'react';
import type { GET_CURRENT_USER_me } from '../../graphql/types/GET_CURRENT_USER';
import React, { Fragment, useContext } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CreativeListContext } from '../../contexts/creativeListContext';
import { MessageContextProvider } from '../../contexts/messageContext';
import ContentLoader from '../ContentLoader';
import Spinner from '../Spinner';
import UserCreativeCardModern from './UserCreativeCardModern';
import { UserData } from '../../types/user';

interface IUserListProps {
  currentUser: GET_CURRENT_USER_me;
}

const UserList: FC<IUserListProps> = ({ currentUser }) => {
  const {
    creatives: users,
    isLoading,
    totalCreatives,
    onFetchMore,
    selectedUserId
  } = useContext(CreativeListContext);

  const filteredUsers = selectedUserId
    ? users.filter(user => user.id === selectedUserId)
    : users;

  const CreativesCardLoader = (
    <Fragment>
      <div className="column">
        <ContentLoader />
      </div>
      <div className="column">
        <ContentLoader />
      </div>
      <div className="column">
        <ContentLoader />
      </div>
    </Fragment>
  );

  if (isLoading && filteredUsers.length === 0) {
    return <div className="columns">{CreativesCardLoader}</div>;
  }

  return (
    <InfiniteScroll
      className="columns page-creatives-userlist is-multiline"
      dataLength={filteredUsers.length}
      hasMore={!selectedUserId && filteredUsers.length < totalCreatives}
      loader={
        <div className="column is-12 page-creatives-userlist-loader">
          <Spinner />
        </div>
      }
      next={onFetchMore}
      scrollThreshold={0.8}
      endMessage={
        <p className="column has-text-centered m-b-3 is-12">
          {filteredUsers.length === 0
            ? 'Nothing to show.'
            : 'No more creatives to show.'}
        </p>
      }
    >
      {filteredUsers &&
        filteredUsers.map((user: UserData) => (
          <MessageContextProvider key={user.id} currentUser={currentUser}>
            <UserCreativeCardModern user={user} currentUser={currentUser} />
          </MessageContextProvider>
        ))}
    </InfiniteScroll>
  );
};

export default UserList;
